import environment from './base';

/*
 * base.js is the default environment for production.
 * You shouldn't have override anything.
 */

const baseApi = 'https://api.dev.video-server.iudx.io';
const env = environment(baseApi);

const productionEnv = {
    ...env,
    // override anything that gets added from base.
};

export default productionEnv;
